import {
  AddressSearch,
  InputGroup,
  InputGroupBreak,
  InputRow,
  RadioYesNoInput,
} from '@equifinance/shared';
import { EmploymentHistory, PartnershipEntry, SoleTraderEntry } from '../../../../../contexts/account/IncomeAndEmployment';
import { StaticDataItem } from '../../../../../api/useAccountApi';
import { useAccountContext } from '../../../../../contexts';
import { HighlightInputGroup } from '../../../components/HighlightInputGroup';

function AddressSearchSection({
  employmentHistory,
  countries,
  field,
}: {
  employmentHistory: SoleTraderEntry | PartnershipEntry,
  countries: StaticDataItem[],
  field: string,
}) {
  const { account } = useAccountContext();
  const { errors } = account ?? {};
  return (
    <AddressSearch
      label="Find company address"
      field={`${field}.address`}
      addressId={employmentHistory?.address?.id}
      countries={countries?.reduce((prev, country) => ({
        ...prev,
        [country?.key]: country?.label,
      }), {} as Record<string, string>)}
      errors={errors}
      searchPlaceholder="Enter postcode or first line of company address"
      subBuildingLabel="Sub-building number"
      buildingNameLabel="Building name"
      buildingNumberLabel="Building number"
    />
  );
}

export default function PositionSectionAddress({
  employmentHistory,
  countries,
  field,
}: {
  employmentHistory: EmploymentHistory,
  countries: StaticDataItem[],
  field: string,
}) {
  if (
    employmentHistory?.employmentType === 'SoleTrader'
    && employmentHistory.currentlyWorkingInThisRole
  ) {
    return (
      <>
        <InputGroupBreak />
        <InputGroup>
          <InputRow>
            <RadioYesNoInput
              label="Is the trading address the same as security address?"
              field={`${field}.isTradingAddressSameAsSecurityAddress`}
              required
            />
          </InputRow>
        </InputGroup>
        {employmentHistory.isTradingAddressSameAsSecurityAddress === false && (
          <HighlightInputGroup>
            <AddressSearchSection
              employmentHistory={employmentHistory}
              countries={countries}
              field={field}
            />
          </HighlightInputGroup>
        )}
      </>
    );
  }
  if (
    employmentHistory?.employmentType === 'Partnership'
    && employmentHistory.currentlyWorkingInThisRole
  ) {
    return (
      <>
        <InputGroupBreak />
        <AddressSearchSection
          employmentHistory={employmentHistory}
          countries={countries}
          field={field}
        />
      </>
    );
  }
  return null;
}
